import type { Options as YoutubeOptions } from 'react-youtube';
import defaultPlayerOptions from './player-options.json';

export const populatePlayerOptionsWithLanguage = (
  playerLanguage?: string,
  playerOpts?: YoutubeOptions
): YoutubeOptions => {
  const castDefaultPlayerOptions = defaultPlayerOptions as YoutubeOptions;

  const newYoutubeOptions = {
    ...castDefaultPlayerOptions,
    ...playerOpts,
    playerVars: {
      ...castDefaultPlayerOptions.playerVars,
      ...playerOpts?.playerVars,
    },
  };

  if (playerLanguage && !playerOpts?.playerVars?.hl) {
    newYoutubeOptions.playerVars.hl = playerLanguage;
  }

  return newYoutubeOptions;
};
